import React from 'react'
import 'materialize-css'
import { CardPanel, Row, Col } from 'react-materialize'


export const EsitoResume = ({datiRichiesta}) => {
    return (
        <>
            {
                datiRichiesta?.checkoutData.paymentNotices.map(
                    (pendenza, i) => <CardPanel key={i}>
                        <Row>
                            <Col s={12}>
                                <p><b>Nominativo Ente Creditore:</b> {pendenza.companyName}</p>
                                <p><b>Codice Fiscale Ente Creditore:</b> {pendenza.fiscalCode}</p>
                                <p><b>Codice Avviso:</b> {pendenza.noticeNumber}</p>
                                <p><b>Causale:</b> {pendenza.description}</p>
                                <p><b>Importo:</b> {pendenza.amount * 0.01}€</p>
                            </Col>
                        </Row>
                    </CardPanel> 
                )
            }
        </>
    );
}